import { Box, Typography } from "@mui/material";
import React from "react";

export default function NotFound() {

    return(
        <Box>
            <Typography variant="h3">Page Not Found</Typography>
        </Box>
    )
}